import { useSelector } from 'react-redux';
import { FEATURE_KEYS as MODULES_FEATURE_KEYS, isFeatureEnabled } from '@/lib/featureModules';

// Re-export for legacy callers (FeaturesSettings etc.). The catalog in
// src/lib/featureModules.js is the source of truth.
export const FEATURE_KEYS = MODULES_FEATURE_KEYS;

export default function useFeatures() {
  const orgSettings = useSelector((state) => state.org.settings);

  // Per-module flag → camelCase module name. Keeps the existing return shape
  // (`useFeatures().reports`, `.riskmize`, etc.) so callers don't need to change.
  return {
    reports: isFeatureEnabled('featureReports', orgSettings),
    geofences: isFeatureEnabled('featureGeofences', orgSettings),
    alerts: isFeatureEnabled('featureAlerts', orgSettings),
    replay: isFeatureEnabled('featureReplay', orgSettings),
    driverSafety: isFeatureEnabled('featureDriverSafety', orgSettings),
    fuel: isFeatureEnabled('featureFuel', orgSettings),
    maintenance: isFeatureEnabled('featureMaintenance', orgSettings),
    pois: isFeatureEnabled('featurePois', orgSettings),
    sharing: isFeatureEnabled('featureSharing', orgSettings),
    displayWall: isFeatureEnabled('featureDisplayWall', orgSettings),
    schoolBus: isFeatureEnabled('featureSchoolBus', orgSettings),
    schoolBusStandard: isFeatureEnabled('featureSchoolBusStandard', orgSettings),
    schoolBusAdvanced: isFeatureEnabled('featureSchoolBusAdvanced', orgSettings),
    commands: isFeatureEnabled('featureCommands', orgSettings),
    routeCalculator: isFeatureEnabled('featureRouteCalculator', orgSettings),
    work: isFeatureEnabled('featureWork', orgSettings),
    scheduledReports: isFeatureEnabled('featureScheduledReports', orgSettings),
    notificationChannels: isFeatureEnabled('featureNotificationChannels', orgSettings),
    carbon: isFeatureEnabled('featureCarbon', orgSettings),
    driverGamification: isFeatureEnabled('featureDriverGamification', orgSettings),
    hos: isFeatureEnabled('featureHOS', orgSettings),
    chat: isFeatureEnabled('featureChat', orgSettings),
    ai: isFeatureEnabled('featureAI', orgSettings),
    crm: isFeatureEnabled('featureCRM', orgSettings),
    forms: isFeatureEnabled('featureForms', orgSettings),
    workTemplates: isFeatureEnabled('featureWorkTemplates', orgSettings),
    temperature: isFeatureEnabled('featureTemperature', orgSettings),
    whatsappBot: isFeatureEnabled('featureWhatsAppBot', orgSettings),
    riskmize: isFeatureEnabled('featureRiskmize', orgSettings),
    snapToRoad: isFeatureEnabled('featureSnapToRoad', orgSettings),
    workAutoComplete: isFeatureEnabled('featureWorkAutoComplete', orgSettings),
    trafficLayer: isFeatureEnabled('featureTrafficLayer', orgSettings),
    aircraftLayer: isFeatureEnabled('featureAircraftLayer', orgSettings),
    aircraftLayerPremium: isFeatureEnabled('featureAircraftLayerPremium', orgSettings),
    liveuamap: isFeatureEnabled('featureLiveuamap', orgSettings),
    weatherLayer: isFeatureEnabled('featureWeatherLayer', orgSettings),
    workforce: isFeatureEnabled('featureWorkforce', orgSettings),
    guardian: isFeatureEnabled('featureGuardian', orgSettings),
    broadcast: isFeatureEnabled('featureBroadcast', orgSettings),
    muster: isFeatureEnabled('featureMuster', orgSettings),
    respond: isFeatureEnabled('featureRespond', orgSettings),
    assure: isFeatureEnabled('featureAssure', orgSettings),
    automation: isFeatureEnabled('featureAutomation', orgSettings),
  };
}
